

import { useState, useEffect } from 'react';
import { API } from '../api/config';


const API_BASE_URL = API.LUDOPEDIA;

export function useGameDetails(gameId) {
    const [gameDetails, setGameDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!gameId) {
            return;
        }

        const fetchDetails = async () => {
            setIsLoading(true);
            setError(null);
            setGameDetails(null);

            try {
                const response = await fetch(`${API_BASE_URL}/jogos/${gameId}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setGameDetails(data);
            } catch (err) {
                console.error("Erro ao buscar detalhes do jogo:", err);
                setError("Não foi possível carregar os detalhes do jogo.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchDetails();
    }, [gameId]);

    return { gameDetails, isLoading, error };
}